import { apiRequest } from './api';

export type FavoriteType = 'activity' | 'pick';

export interface FavoriteIds {
  activity: string[];
  pick: string[];
}

/** open = public now; ended = finished but still viewable; unlisted = taken down. */
export type FavoriteState = 'open' | 'ended' | 'unlisted';

export interface FavoriteActivityItem {
  id: string;
  slug: string;
  kind: 'activity' | 'course';
  titleCN: string | null;
  titleEN: string | null;
  imageUrl: string | null;
  state: FavoriteState;
  favoritedAt: string;
}

export interface FavoritePickItem {
  id: string;
  slug: string;
  type: 'PROVIDER' | 'EVENT';
  category: string;
  titleCN: string | null;
  titleEN: string | null;
  state: FavoriteState;
  favoritedAt: string;
}

export interface FavoriteList {
  activities: FavoriteActivityItem[];
  picks: FavoritePickItem[];
}

/** Favorites (docs/prd-homepage-redesign.md §5.9). All calls need a signed-in user. */
export const favoritesApi = {
  /** My Home list with each item's state (F4). */
  async list(): Promise<FavoriteList> {
    const res = await apiRequest<{ success: boolean; data: FavoriteList }>('/favorites');
    return res.data;
  },
  async listIds(): Promise<FavoriteIds> {
    const res = await apiRequest<{ success: boolean; data: FavoriteIds }>('/favorites/ids');
    return res.data;
  },
  async add(type: FavoriteType, id: string): Promise<void> {
    await apiRequest(`/favorites/${type}/${encodeURIComponent(id)}`, { method: 'PUT' });
  },
  async remove(type: FavoriteType, id: string): Promise<void> {
    await apiRequest(`/favorites/${type}/${encodeURIComponent(id)}`, { method: 'DELETE' });
  },
};
